export default __webpack_public_path__ + "static/media/swf-banner-mobile.5560222e.jpg";